module.exports = __webpack_public_path__ + "img/243.ecc0a7dd.png";